module.exports = __webpack_public_path__ + "static/media/03.c61ddfbd.jpg";